import useMwdTimescale from './useMwdTimescale';

const useMiniMwdTimescale = () => useMwdTimescale('miniMwd');

export default useMiniMwdTimescale;
